import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const light = (params) => primaryButtonHover(params);

export default light;
